import { useTranslation } from "react-i18next";
import { useCurrencies } from "@/shared/lib/session";
import { Field } from "./Field";

/** Currencies a company can choose from in its settings. */
export const CURRENCIES = ["EGP", "SAR", "AED", "KWD", "QAR", "BHD", "OMR", "USD", "EUR", "GBP"];

/**
 * The currency choices for a record: the company's currencies (see useCurrencies), plus
 * the record's own if it's in another. Empty when there is nothing to choose, so the
 * field stays out of the way of a company that deals in its base currency only.
 */
export function currencyChoices(currencies: string[], value: unknown): string[] {
  if (typeof value === "string" && value && !currencies.includes(value)) return [...currencies, value];
  return currencies.length > 1 ? currencies : [];
}

/** A document's currency, shown only when the company deals in more than one. */
export function CurrencyField({ value, onChange, disabled, className }: {
  value: string; onChange: (c: string) => void; disabled?: boolean; className?: string;
}) {
  const { t } = useTranslation();
  const choices = currencyChoices(useCurrencies(), value);
  if (choices.length === 0) return null;
  return (
    <Field label={t("common.currency")} className={className}>
      <select className="field" value={value} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
        {choices.map((c) => <option key={c}>{c}</option>)}
      </select>
    </Field>
  );
}
